import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Interformation from '../views/Interformation/index.vue'
import InfoDetail from '../views/Interformation/detail.vue'
import IndustryDock from '../views/IndustryDock/index.vue'
import countryMe from '../views/countryMe/index.vue'
import GlobalTrend from '../views/GlobalTrend/index.vue'
import governance from '../views/governance/index.vue'
import applicationProcess from '../views/applicationProcess/index.vue'
import activeDetail from '../views/Centraloutcome/detail.vue'

import Centraloutcome from '../views/Centraloutcome/index.vue'
import Aboutus from '../views/Aboutus/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'/home'
  },
  {
    path: '/home',
    name: '首页',
    component: HomeView
  },
  {
    path: '/casedisplay',
    name: '产业对接',
    component: IndustryDock,
  },
  {
    path: '/countryMe',
    name: '应用赋能',
    component: countryMe,
  },
  {
    path: '/Interformation',
    name: '信息交流',
    component: Interformation,
  },
  {
    path: '/InfoDetail',
    name: '详情',
    component: InfoDetail,
  },
  {
    path: '/GlobalTrend',
    name: 'GlobalTrend',
    component: GlobalTrend,
  },
  {
    path: '/governance',
    name: '治理合作',
    component: governance,
  },
  {
    path: '/applicationProcess',
    name: 'applicationProcess',
    component: applicationProcess,
  },
  {
    path: '/Centraloutcome',
    name: '中心成果',
    component: Centraloutcome,
  },
  {
    path: '/Aboutus',
    name: '关于我们',
    component: Aboutus,
  },
  {
    path: '/activeDetail',
    name: '活动详情',
    component: activeDetail,
  }
]
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果savedPosition存在，则回到保存的位置
      return savedPosition;
    } else {
      // 如果是通过一级菜单点击进入，则滚动到顶部
      return { x: 0, y: 0 };
    }
  }
})

export default router
